export default "__VITE_ASSET__DGwg$qDv__"